/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/from_email_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdFromEmailDomains } from "./constants";
import type { FromEmailDomain } from "./types";

export const getFromEmailDomains = reactQueryFetcherAdapter(
  engagementAppGroupIdFromEmailDomains,
  (signal: AbortSignal, appGroupId: string): Promise<FromEmailDomain[]> => {
    return fetch(`/engagement/${appGroupId}/from_email_domains`, "GET", { query: "" }, { signal });
  }
);
